import { Compass } from 'lucide-react';

interface LoadingScreenProps {
  className?: string;
}

export default function LoadingScreen({ className = 'min-h-screen' }: LoadingScreenProps) {
  return (
    <div className={`${className} bg-[#f8f9fa] flex flex-col items-center justify-center gap-7`}>
      <div className="flex items-center gap-2.5">
        <Compass size={30} className="text-primary" />
        <span className="text-[#1A1A1A] text-2xl font-bold">Tripway</span>
      </div>
      <div className="relative w-12 h-12">
        <div className="absolute inset-0 rounded-full border-4 border-[#E8E8E8]" />
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-primary animate-spin" />
      </div>
      <span className="text-[#999999] text-sm font-medium">載入中...</span>
    </div>
  );
}
